import * as React from 'react'

import NotFound from 'modules/core/components/NotFound'

import { usePayrollPaywallingGuard } from 'modules/payroll_bundle/hooks/usePayrollPaywallGuard'

interface PayrollPaywallGuardProps {
  children: React.ReactNode
}

const PayrollPaywallGuard = ({ children }: PayrollPaywallGuardProps) => {
  const { loadingFeatures, isPayrollAvailable } = usePayrollPaywallingGuard()

  if (loadingFeatures) return <div data-testid="loading-payroll-feature"></div>

  if (!isPayrollAvailable) return <NotFound />

  return <>{children}</>
}

export default PayrollPaywallGuard
